<div class="modify-session-action-bar">
  <ng-container *ngIf="phase === 'finalized'">
    <button
      mat-raised-button color="primary" type="button"
      data-balance-summary-modify
      [disabled]="!canModify || busy"
      (click)="emitVoid(modify)"
    >
      <mat-icon>edit</mat-icon>
      <span>{{ 'balance.modify-session.modify' | translate }}</span>
    </button>

    <button
      mat-stroked-button type="button"
      data-balance-summary-history
      [disabled]="!canViewHistory || busy"
      (click)="emitVoid(viewHistory)"
    >
      <mat-icon color="primary">history</mat-icon>
      <span>{{ 'balance.summary.view-history' | translate }}</span>
    </button>

    <button
      mat-stroked-button color="warn" type="button"
      data-balance-summary-void
      [disabled]="!canVoid || busy"
      (click)="emitVoid(void)"
    >
      <mat-icon color="warn">delete</mat-icon>
      <span>{{ 'balance.modify-session.void' | translate }}</span>
    </button>

    <button
      mat-stroked-button type="button"
      [matMenuTriggerFor]="sendMenu"
      data-balance-summary-send
      [disabled]="!canSend || busy"
    >
      <mat-icon>send</mat-icon>
      <span>{{ 'balance.summary.send' | translate }}</span>
    </button>
    <mat-menu #sendMenu="matMenu">
      <button mat-menu-item type="button" [disabled]="!canSendEmail || busy" data-balance-summary-send-email (click)="emit(send, 'email')">
        <mat-icon>email</mat-icon>
        <span>{{ 'balance.summary.send-email' | translate }}</span>
      </button>
      <button mat-menu-item type="button" [disabled]="!canSendSms || busy" data-balance-summary-send-sms (click)="emit(send, 'sms')">
        <mat-icon>sms</mat-icon>
        <span>{{ 'balance.summary.send-sms' | translate }}</span>
      </button>

      <mat-divider></mat-divider>

      <button mat-menu-item type="button" [disabled]="!canSendDocument || busy" data-balance-summary-send-document (click)="emitVoid(sendDocument)">
        <mat-icon>send</mat-icon>
        <span>{{ 'balance.summary.send-document' | translate }}</span>
      </button>
    </mat-menu>

    <button
      mat-stroked-button type="button"
      data-balance-summary-print-letter
      [disabled]="!canPrintLetter || busy"
      (click)="emitVoid(printLetter)"
    >
      <mat-icon>print</mat-icon>
      <span>{{ 'balance.summary.print-letter' | translate }}</span>
    </button>
  </ng-container>

  <ng-container *ngIf="phase === 'modifyPreCalc'">
    <button
      mat-raised-button color="primary" type="button"
      data-balance-summary-calculate
      [disabled]="!canCalculate || busy"
      (click)="emitVoid(calculate)"
    >{{ 'balance.charges.calculate' | translate }}</button>

    <button
      mat-stroked-button type="button"
      data-balance-summary-discard
      [disabled]="busy"
      (click)="emitVoid(discard)"
    >
      <mat-icon>undo</mat-icon>
      <span>{{ 'balance.modify-session.discard' | translate }}</span>
    </button>
  </ng-container>

  <ng-container *ngIf="phase === 'modifyPostCalc'">
    <button
      mat-raised-button color="primary" type="button"
      data-balance-summary-finalize
      [disabled]="!canFinalize || busy"
      (click)="emitVoid(finalize)"
    >{{ 'balance.review.finalize-all' | translate }}</button>

    <button
      mat-stroked-button type="button"
      data-balance-summary-discard
      [disabled]="busy"
      (click)="emitVoid(discard)"
    >
      <mat-icon>undo</mat-icon>
      <span>{{ 'balance.modify-session.discard' | translate }}</span>
    </button>
  </ng-container>
</div>
